import { FC } from 'react'
import cx from 'classnames'
import Styles from './RightRail.module.scss'
import { observer } from 'mobx-react-lite'
import { useLayout } from 'stores/LayoutStore'

const RightRail: FC<React.PropsWithChildren<unknown>> = observer(({ children }) => {
  const layout = useLayout()

  return <div className={cx(Styles.root, { [Styles.collapsed]: !layout.rightColumnLocked })}>{children}</div>
})

export { RightRail }
